export const TASK_COMMENT_MAX_TEXT_LENGTH = 2000;
export const TASK_COMMENT_MAX_FILES = 10;
// Symfony File(maxSize="25M") использует десятичные мегабайты.
export const TASK_COMMENT_MAX_FILE_SIZE_BYTES = 25_000_000;
export const TASK_COMMENTS_POLLING_INTERVAL = 3000;
